import { render, staticRenderFns } from "./NotifyDetail.vue?vue&type=template&id=22d497bb&scoped=true&"
import script from "./NotifyDetail.vue?vue&type=script&lang=js&"
export * from "./NotifyDetail.vue?vue&type=script&lang=js&"
import style0 from "./NotifyDetail.vue?vue&type=style&index=0&id=22d497bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d497bb",
  null
  
)

export default component.exports